import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ISnackMsg, SnackTypeMsg } from 'src/app/model/snackmsg/snackmsg.model';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent {

  Types = SnackTypeMsg;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ISnackMsg,
    private readonly snackRef: MatSnackBarRef<SnackbarComponent>
  ) {

  }

  onClose() {
    this.snackRef.dismissWithAction();
  }

  onView(){

    this.data?.callback();

  }

}
